import { useState } from "react"
import { OrderFilterType } from "./helpers"

export function useOrderTypeFilter(initialValue: OrderFilterType = OrderFilterType.ALL) {
    const [orderType, setOrderType] = useState<OrderFilterType>(initialValue)

    return {
        orderType,
        setOrderType,
    }
}
